import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Inline = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M1.5 4C1.5 3.72386 1.72386 3.5 2 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4C14.5 4.27614 14.2761 4.5 14 4.5H2C1.72386 4.5 1.5 4.27614 1.5 4ZM1.5 8C1.5 7.72386 1.72386 7.5 2 7.5H3.5C3.77614 7.5 4 7.72386 4 8C4 8.27614 3.77614 8.5 3.5 8.5H2C1.72386 8.5 1.5 8.27614 1.5 8ZM12 8C12 7.72386 12.2239 7.5 12.5 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H12.5C12.2239 8.5 12 8.27614 12 8ZM2 11.5C1.72386 11.5 1.5 11.7239 1.5 12C1.5 12.2761 1.72386 12.5 2 12.5H7.66667C7.94281 12.5 8.16667 12.2761 8.16667 12C8.16667 11.7239 7.94281 11.5 7.66667 11.5H2ZM6 7.5H10V8.5H6V7.5ZM5 7.5C5 6.94772 5.44772 6.5 6 6.5H10C10.5523 6.5 11 6.94772 11 7.5V8.5C11 9.05228 10.5523 9.5 10 9.5H6C5.44772 9.5 5 9.05228 5 8.5V7.5Z"
      />
    </svg>
  )
})

export default Inline
